<template>
  <div class="home">
    <header class="header-1" v-if="!userInfo.userName">
      <router-link to="/login">用户登录</router-link>
      <router-link to="/register">用户注册</router-link>
    </header>
    <header class="header-2" v-if="userInfo.userName">
      <div class="left">
        <router-link to="/">个人中心</router-link>
        <router-link to="/court">我的开庭</router-link>
        <router-link to="/sign">笔录签名</router-link>
      </div>
      <div class="right">
        <span> <img src="../assets/icon_check_user.png" alt=""> 欢迎您，{{ userInfo.userName }} </span>
        <span class="click" @click="_exit"> <img src="../assets/icon_check_exit.png" alt=""> 退出账户 </span>
      </div>
    </header>
    <section>
      <div class="logo">
        <img src="../assets/logo.png"  />
      </div>
      <div class="menu">
        <a href="https://lian.zjac.org/">
          <div class="icon">
            <img src="../assets/icon_home_lian.png"  />
          </div>
          <p>网上立案</p>
        </a>
        <router-link to="/check">
          <div class="icon">
            <img src="../assets/icon_home_kaiting.png" alt />
          </div>
          <p>网上开庭</p>
        </router-link>
        <!-- <a @click="showUpdateTip">
          <div class="icon">
            <img src="../assets/icon_home_chaxun.png"  />
          </div>
          <p>案件查询</p>
        </a> -->
        <a href="http://acc.zjac.org" target="_blank">
          <div class="icon">
            <img src="../assets/icon_home_anjian.png" alt />
          </div>
          <p>案件查询</p>
        </a>
      </div>
      <div class="right-menu">
        <a href="https://iac.zjac.org/" target="_blank">
          <div class="icon">
            <img src="../assets/icon_home.png"  />
          </div>
          <p>湛江仲裁</p>
        </a>
        <router-link to="/">
          <div class="icon">
            <img src="../assets/icon_home_wx.png"  />
          </div>
          <p>湛仲小程序</p>
          <div class="code">
            <img src="../assets/code.jpg" alt="">
            <p>请用微信扫一扫</p>
          </div>
        </router-link>
        <a href="https://help.zjac.org/" target="_blank">
          <div class="icon">
            <img src="../assets/icon_home_help.png"  />
          </div>
          <p>帮助指引</p>
        </a>
        <a href="https://www.zjac.org/facade/brief/detail/57" target="_blank">
          <div class="icon">
            <img src="../assets/icon_home_call.png"  />
          </div>
          <p>联系我们</p>
        </a>
      </div>
    </section>
    <footer>
      <div class="menu">
        <a href="https://www.zjac.org/facade/brief/detail/218" target="_blank">
          <div class="icon">
            <img src="../assets/icon_home_jianjie.png"  />
          </div>
          <p>湛仲简介</p>
          <div class="bg"></div>
        </a>
        <a class="no" href="https://www.zjac.org/facade/guide/detail/86" target="_blank">
          <div class="icon">
            <img src="../assets/icon_home_youshi.png"  />
          </div>
          <p>仲裁优势</p>
          <div class="bg"></div>
        </a>
        <a  href="https://www.zjac.org/facade/client/calculation" target="_blank" >
          <div class="icon">
            <img src="../assets/icon_home_jisuan.png" />
          </div>
          <p>仲裁费计算</p>
          <div class="bg"></div>
        </a>
        <a  href="https://www.zjac.org/facade/other/document" target="_blank" >
          <div class="icon">
            <img src="../assets/icon_home_faben.png"  />
          </div>
          <p>合同范本</p>
          <div class="bg"></div>
        </a>
        <a href="https://www.zjac.org/facade/guide/nous/detail/214" target="_blank">
          <div class="icon">
            <img src="../assets/icon_home_fanwei.png" alt />
          </div>
          <p>受案范围</p>
          <div class="bg"></div>
        </a>
        <a href="https://www.zjac.org/facade/guide/nous/catalog" target="_blank">
          <div class="icon">
            <img src="../assets/icon_home_chengxu.png" alt />
          </div>
          <p>仲裁程序</p>
          <div class="bg"></div>
        </a>
        <a href="https://www.zjac.org/facade/other/letters" target="_blank">
          <div class="icon">
            <img src="../assets/icon_home_tousu.png"  />
          </div>
          <p>我要投诉</p>
          <div class="bg"></div>
        </a>
        <a href="https://www.zjac.org/facade/brief/detail/57" target="_blank">
          <div class="icon">
            <img src="../assets/icon_home_zixun.png" alt />
          </div>
          <p>联系咨询</p>
          <div class="bg"></div>
        </a>
      </div>
    </footer>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'Home',
  computed: mapState(['userInfo']),
  methods: {
    _exit () {
      const _this = this
      window.localStorage.clear()
      _this.$store.commit('SET_USER_INFO', {})
      _this.$message.success('退出登录')
    },
    showUpdateTip () {
      const _this = this
      _this.$message.success('系统更新中...')
    }
  }
}
</script>

<style lang="scss">
@import "../style/mixin";
@keyframes sx {
  0% {
    top:10px;
  }

  100% {
    top:-10px;
  }
}
.home {
  position: relative;
  @include wh(100%, 100%);
  background-image: url("../assets/home_bg.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  footer {
    margin-top: 1.417rem;
    .menu {
      @include wh(11.725rem, 1.233rem);
      position: relative;
      z-index: 2;
      display: flex;
      border-radius: 0.167rem;
      background-color: rgba(255, 255, 255, 1);
      box-shadow: 0rem 0rem 0.4rem 0rem rgba(0, 103, 179, 0.33);
      margin: 0 auto;
      text-align: center;
      font-size: 0.167rem;
      a {
        position: relative;
        flex: 1;
        background-color: rgba(255, 255, 255, 0.97);
        &:first-child {
          border-radius: 0.167rem 0 0 0.167rem;
        }
        &:last-child {
          border-radius: 0 0.167rem 0.167rem 0;
        }
        .bg {
          position: absolute;
          z-index: -2;
          background-color: #006fb7;
          width: 0;
          height: 1.608rem;
          top: -0.1875rem;
          margin: 0 0.25%;
          border-radius: 0.083rem;
          transition: all .3s;
        }
        .icon {
          margin-top: 0.317rem;
          img {
            height: 0.3rem;
            width: auto;
          }
        }
        p {
          font-family: PingFang SC;
          font-weight: 500;
          color: #666666;
          margin-top: 0.167rem;
        }
      }
      a:hover {
        .bg {
          width: 100%;
        }
        p {
          color: #003485;
        }
        // &::after {
        //   position: absolute;
        //   z-index: 2;
        //   content: " ";
        //   top: -0.078rem;
        //   left: 50%;
        //   margin-left: -0.078rem;
        //   background-color: #006fb7;
        //   @include wh(0.156rem, 0.156rem);
        //   border-radius: 0.156rem;
        // }
        // &::before {
        //   position: absolute;
        //   z-index: 2;
        //   content: " ";
        //   bottom: -0.078rem;
        //   left: 50%;
        //   margin-left: -0.078rem;
        //   background-color: #006fb7;
        //   @include wh(0.156rem, 0.156rem);
        //   border-radius: 0.156rem;
        // }
      }
    }
  }
  section {
    position: relative;
    .right-menu {
      position: absolute;
      right: 0.317rem;
      top: 0.208rem;
      text-align: center;
      font-size: 0.167rem;
      font-family: PingFang SC;
      font-weight: 500;
      a:hover {
        .code  {
          display: block;
          position: absolute;
          left: -310%;
          width: 300%;
          height: 300%;
          top: 0;
          background-color: rgba(0, 50, 84, 0.59);
          img {
            width: 50%;
            height: 50%;
            margin-top: 15%;
          }
        }
      }
      a {
        position: relative;
        display: block;
        @include wh(1.008rem, 1.008rem);
        background-color: rgba(0, 50, 84, 0.59);
        margin-top: 1px;
        &:first-child {
          border-radius: 0.1rem 0.1rem 0rem 0rem;
        }
        &:last-child {
          border-radius: 0rem 0rem 0.1rem 0.1rem;
        }
        p {
          color: #ffffff;
          margin-top: 0.242rem;
        }
        .icon {
          img {
            margin-top: 0.158rem;
            width: auto;
            height: 0.283rem;
          }
        }
        .code {
          display: none;
        }
      }
    }
    .logo {
      @include wh(4.5rem, 1.083rem);
      margin: 0 auto;
      img {
        @include wh(100%, 100%);
      }
    }
    .menu {
      display: flex;
      width: 11.725rem;
      margin: 0 auto;
      text-align: center;
      margin-top: 1.117rem;
      a {
        flex: 1;
        font-size: 0.2rem;
        font-family: PingFang SC;
        font-weight: 500;
        .icon {
          position: relative;
          @include wh(1.158rem, 1.3rem);
          margin: 0 auto;
          &:hover {
            transform: scale(1.2);
            transition: top .3s;
            animation: sx .5s infinite linear alternate;
          }
          img {
            @include wh(100%, 100%);
          }
        }
        p {
          margin-top: 0.317rem;
        }
      }
    }
  }
  .header-2 {
    padding: 0 0.458rem;
    height: 0.883rem;
    line-height: 0.883rem;
    a {
      font-size: 0.15rem;
      font-family: PingFang SC;
    }
    .right {
      color: #4A4A4A;
      img {
        @include wh(0.167rem, 0.167rem);
        vertical-align: middle;
        margin-right: 0.133rem;
      }
      .click {
        margin-left: 0.517rem;
        position: relative;
        &::after {
          position: absolute;
          content: ' ';
          left: -0.25rem;
          background-color: #4A4A4A;
          top: 0;
          bottom: 0;
          width: 0.025rem;
          border-radius: 0.013rem;
        }
      }
    }
    .left {
      a {
        color: #fff;
        font-weight: bold;
        background-color: #2176C1;
        padding: 0.133rem 0.283rem;
        border-radius: 0.208rem;
        margin-right: 0.125rem;
      }
    }
  }
  .header-1 {
    font-size: 0.15rem;
    font-family: PingFang SC;
    font-weight: bold;
    padding-top: 0.425rem;
    overflow: auto;
    a {
      display: inline-block;
      color: #fbf9fb;
      background-color: #275e9f;
      border: 0.008rem solid #5e88b8;
      border-radius: 0.083rem;
      padding: 0.092rem 0.183rem;
      margin-left: 1.2rem;
      &:last-child {
        margin-left: 0.2rem;
      }
    }
  }
}
</style>
